import _ from 'lodash';

const createRateCodePreferenceMap = (rateCodes) => {
  if (!Array.isArray(rateCodes) || rateCodes.length === 0) return null;
  try {
    const rateCodeMap = new Map();

    rateCodes
      .filter((rc) => rc?.rateCode)
      .forEach((rc) => {
        if (!rateCodeMap.has(rc.rateCode)) {
          rateCodeMap.set(rc.rateCode, rc.order || 0);
        }
      });

    return rateCodeMap;
  } catch (ex) {
    console.error('An error occurred while creating the rate code preference map.', ex);
    return null;
  }
};

const getPrioritizedProducts = (products, rateCodePreferences) => {
  if (!products?.length || !rateCodePreferences?.size) {
    return null;
  }

  try {
    const roomInfos = products
      .filter((product) => product?.rooms)
      .flatMap((product) => product.rooms.map((room) => ({
        product,
        room,
        price: product.roomPrice?.markupPrice || 0,
        description: room?.originalDesc || room?.desc || room?.description || '',
        ratePlanCode: room?.ratePlanClientId || room?.ratePlanCode || '',
      })));

    const groupedProducts = _.groupBy(roomInfos, (roomInfo) => `${roomInfo.price}-${roomInfo.description}-${roomInfo.product.refundType}-${(roomInfo.product.ValueAdds ?? []).slice().sort().join('|')}`);

    return Object.values(groupedProducts).map((group) => {
      const sortedRooms = _.sortBy(group,
        (roomInfo) => rateCodePreferences.get(roomInfo.ratePlanCode) ?? Infinity);
      return sortedRooms[0].product;
    });
  } catch (ex) {
    console.error('An error occurred while prioritizing hotel products.', ex);
    return products;
  }
};

const prioritizeHotelRates = (hotelDetails, travelAgency, hotelRateCodes) => {
  if (
    !travelAgency?.settings?.doHideDuplicateHotelRates
    || !hotelDetails?.hotel?.products?.length
  ) {
    return hotelDetails;
  }

  const rateCodePreferences = createRateCodePreferenceMap(hotelRateCodes);
  if (!rateCodePreferences?.size) {
    return hotelDetails;
  }

  const prioritizedProducts = getPrioritizedProducts(
    hotelDetails.hotel.products,
    rateCodePreferences,
  );

  if (!prioritizedProducts?.length) {
    return hotelDetails;
  }

  const updatedHotelDetails = _.cloneDeep(hotelDetails);
  updatedHotelDetails.hotel.products = prioritizedProducts;
  return updatedHotelDetails;
};

export default prioritizeHotelRates;
